import Vue from 'vue'

import BaseSearch from './common/baseSearch.vue'
import BaseSearchItem from './common/BaseSearchItem.vue'
import BaseTable from './common/baseTable.vue'
import BaseTooltip from './common/BaseToolTip.vue'
import IconTitle from './common/iconTitle.vue'
import BaseDataCard from './common/baseDataCard.vue'
import BaseForm from './common/baseForm.vue'
import BaseLoading from './common/baseLoading.vue'

export function registerGlobComponents() {
  Vue.component('BaseSearch', BaseSearch)
  Vue.component('BaseSearchItem', BaseSearchItem)
  Vue.component('BaseTable', BaseTable)
  Vue.component('BaseTooltip', BaseTooltip)
  Vue.component('IconTitle', IconTitle)
  Vue.component('BaseDataCard', BaseDataCard)
  Vue.component('BaseForm', BaseForm)
  Vue.component('BaseLoading', BaseLoading)
}



// WEBPACK FOOTER //
// ./src/components/register.js